import { useContext,createContext,useState,useEffect } from "react";
import { getTokens ,getNovaPrice} from "../service/main/api";
const TokenContext = createContext();
export const useTokenContext = () => useContext(TokenContext);


export const TokenProvider = ({ children }) => {
    const [tokens, setTokens] = useState([]);
    const [novaPrice, setNovaPrice] = useState(0);
    const getTokensFromService = async () => {
        try {
            const res = await getTokens();
            if(res?.success){
                setTokens(res.data);
            }else{
                console.error("Error fetching tokens", res.message);
            }
           
        } catch (error) {
            console.error("Error fetching tokens", error);
        }

    }
    const fetchNovaPrice = async () => {
        const res = await getNovaPrice();
        setNovaPrice(res?.success ? Number(res.data) : 0);
    }
    useEffect(() => {
        getTokensFromService();
        fetchNovaPrice();   
    }
    , []);
    return (
        <TokenContext.Provider value={{ tokens, novaPrice }}>
            {children}
        </TokenContext.Provider>
    );
};